import React from 'react';
import styled from 'styled-components';
import StripeProductComponent from './StripeProduct';
import { useStripeProducts } from '../context/stripe_products_context';
import Loading from './Loading';

const StripeProductList: React.FC = () => {
  const { stripeProducts, stripeProductsLoading, stripeProductsError } = useStripeProducts();

  if (stripeProductsLoading) {
    return <Loading />;
  }

  if (stripeProductsError) {
    return (
      <Wrapper>
        <div className='section-center'>
          <h2>Error loading Stripe products</h2>
          <p>Please try again later.</p>
        </div>
      </Wrapper>
    );
  }

  if (stripeProducts.length === 0) {
    return (
      <Wrapper>
        <div className='section-center'>
          <h2>No Stripe products found</h2>
          <p>There are currently no products available from Stripe.</p>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div className='section-center'>
        <div className='products-container'>
          {stripeProducts.map((product) => (
            <StripeProductComponent key={product.id} product={product} />
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .section-center {
    width: 90vw;
    margin: 0 auto;
    max-width: 1170px;
  }
  .products-container {
    display: grid;
    gap: 2rem 1.5rem;
    margin: 4rem auto;
  }
  @media (min-width: 576px) {
    .products-container {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    }
  }
  @media (min-width: 768px) {
    .products-container {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    }
  }
  @media (min-width: 992px) {
    .products-container {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    }
  }
`;

export default StripeProductList; 